<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">考试查询</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem text-center">
                        <el-select v-model="queryForm.xnxqbm" filterable placeholder="学年学期" style="width: 240px;" @change="changeTerm">
                            <el-option v-for="item in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有考试信息</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">考试名称：</label>{{ item.examName }}</p>
                        <p><label for="">学年学期：</label>{{ item.xnxqmc }}</p>
                        <p><label for="">考试类型：</label>{{ item.examTypeName }}</p>
                        <div class="auditStateImg">
                            <img v-if="item.selState=='1'" :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput">
                        <el-button type="primary" @click="showExamInfo(item, 'show')">详情</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="examInfoDialog" class="formDialog" :title="examForm.examName" :visible.sync="examInfoDialogVisible" v-if="examInfoDialogVisible" width="90%" top="-20px">
                <examTimeTableMobile :key="timer" ref="examchild" style="height:75vh;" :transXnxqbm="examForm.xnxqbm" :transKcapzbbh="examForm.kcapzbbh" :transExamName="examForm.examName" :transClassCode="examForm.classCode"
                    :transTeacherCode="examForm.teacherCode" :transSearchType="examForm.searchType" :transUserAuth="userAuth" :transExamType="examForm.examType"></examTimeTableMobile>
            </el-dialog>

        </div>
    </div>
</template>
<script>
    import { confirmMsg, showNotify } from "utils/message";
    import examTimeTableMobile from 'views/mobile/examTimeTableMobile.vue';

    export default {
        components: {
            examTimeTableMobile,
        },
        data() {
            return {
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: null,
                },
                examForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: null,
                    examName: null,
                    searchType: null,
                    teacherName: null,
                    kcapzbbh: null,
                    examType: null,
                    classCode: null,
                    teacherCode: null,
                },
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                xnxqInfo: [], //学年学期下拉框
                courseTypeInfo: [], //课程类型下拉框
                courseInfo: [], //课程下拉框
                classInfo: [],//班级下拉框
                stateInfo: [],//状态下拉框
                majorInfo: [],//专业下拉框
                gradeInfo: [],//年级下拉框
                tableData: [],
                currentXnxq: null,//当前学期
                checkSelection: false,//是否在选课时间范围内
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: null,
                mainTableHeight: 500,
                dialogTitle: "",
                dialogVisible: false,
                formSubmiting: false,
                editType: null,
                searchTypeInfo: [],
                examInfoDialogVisible:null,
                userAuth: null,
                timetdHeight: 100,
                timer: '', //时间戳,点击重新加载子页面

                //课表基本参数
                weekDayNum: null,
                weekDayName: null,
                forenoonNum: null,
                noonNum: null,
                afternoonNum: null,
                eveningNum: null,
                timeQuantum: [],
                weekInfo: [],
                //课表内容
                timetableInfo: null,
                cellContent: [],
                timetableLoading: false,
            };
        },
        created() {
            this.initParam();
        },
        mounted() {
            this.searchTypeInfo = [{"comboValue":"1","comboName":"班级查询"},{"comboValue":"2","comboName":"教师查询"}];
            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                this.topHeight = (window.innerHeight-274-200) / 2 +'px';

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            initParam(){
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.common.comboOption.semester({
                    data: paramMap
                }).then(response => {
                    this.xnxqInfo = response.data.data.comboData;
                    this.queryForm.xnxqbm = this.xnxqInfo[0].comboValue;
                    this.examForm.xnxqbm = this.xnxqInfo[0].comboValue;
                    this.initOption();
                    this.queryList();
                }).catch(error => {
                    console.log(error);
                });
            },
            initOption(){
                const paramMap = {
                    'xnxqbm': this.queryForm.xnxqbm
                }
                this.$api.examManage.examSearch.initOption({
                    data: paramMap
                }).then(response => {
                    this.userAuth = response.data.data.userAuth;
                    if(this.userAuth=="1"){
                        this.examForm.searchType = "1";
                    }else if(!this.userAuth=="1" && !this.userAuth=="8"){
                        this.examForm.searchType = "2";
                    }else if(this.userAuth=="8"){
                        this.examForm.searchType = "1";
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.examManage.examSearch.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            changeTerm() {
                this.queryList();
            },
            rowClick(row) {
                this.selectRowData = row;
            },
            handleScroll(){
                if(this.checkVisible() && !this.tableLoading && this.total>this.tableData.length){
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if(ele){
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }else{
                    return false;
                }
            },
            scrollToTop(){
                const ele = document.getElementById('listArea');
                if(ele){
                    ele.scrollTop = 0;
                }
            },
            //显示考试详情
            showExamInfo(row){
                this.timer = new Date().getTime();

                this.examForm.xnxqbm = row.xnxqbm;
                this.examForm.kcapzbbh = row.kcapzbbh;
                this.examForm.examName = row.examName;
                this.examForm.examType = row.examType;
                //this.queryExamTimetable("1");
                this.examInfoDialogVisible = true;
            },
            queryExamTimetable(val){
                if(val=="1"){
                    this.queryClassTree();
                }else{
                    this.queryTeaTree();
                }
                //调用子页面方法
                //this.$refs.examchild.clearDetail();
            },
            loadStateImg(row){
                if(row.selState==='1'){
                    //已选课
                    return require('image/mobile/auditState/ybm.png');
                }
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.xnxqbm = this.xnxqInfo[0].comboValue;
                this.queryForm.electiveClassName = "";
                this.queryForm.classCode = "";
                this.queryForm.studentCode = "";
                this.queryForm.studentName = "";

                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            closeErrorDialog() {
                this.errorMessage = '';
                this.errorDialogVisible = false;
            },
            closeExamInfoDialog(){
                this.examInfoDialogVisible = false;
            },
        },
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode #queryArea {
        height: 40px;
        margin: 10px 0 10px 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #listArea {
        height: calc(100% - 140px);
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// examSchedule.vue?702885f3